import * as React from 'react';
import styled from 'styled-components';
import * as Btn from '../Button';
import { Styledes, Closeable, Childable } from './types';

export interface Props extends Styledes, Closeable, Childable {}

const Cancel = styled(Btn.Normal)`
    margin-left: 1em;
`;

export default React.memo(({ children, className, handleClose }: Props) => {
    return (
        <Cancel 
            onClick={handleClose}
            className={className}>
            {children}
        </Cancel>
    )
});
